import * as React from 'react';
import { useRouter } from '@belong/common/useRouter';
import { IconFb } from '@belong/icons/dist/IconFb';
import { IconTwitter } from '@belong/icons/dist/IconTwitter';
import { IconLinkedin } from '@belong/icons/dist/IconLinkedin';
import { IconInstagram } from '@belong/icons/dist/IconInstagram';
import clsx from 'clsx';
import { Image } from '../Image/Image.js';
import { Link } from '../Link/Link.js';
import { LinkBase } from '../LinkBase/LinkBase.js';
import { Text } from '../Text/Text.js';
import css from './Footer.module.css.js';
import { BELONG_PRO_LINKS, WHO_WE_ARE_COLUMN_LINKS, SUPPORT_COLUMN_LINKS } from './constants.js';

function FooterLink({
  pathname,
  to,
  search,
  shallow,
  label
}) {
  const href = to || {
    pathname,
    search
  };
  return /*#__PURE__*/React.createElement(Link, {
    href: href,
    shallow: shallow
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "body",
    fontWeight: "semibold",
    className: "lg:p1"
  }, label));
}
function Footer() {
  const {
    pathname,
    asPath
  } = useRouter();
  let routerPathname = pathname;
  // Using asPath in Next because it can be a dynamic route
  if (asPath) {
    routerPathname = new URL(asPath, 'http://n').pathname;
  }
  return /*#__PURE__*/React.createElement("footer", {
    className: "container py-2xl mb-3xl "
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('grid gap-3xl md:gap-4xl mb-xl', css.footerTopGrid)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mb-xl md:mb-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[33px] mr-xs"
  }, /*#__PURE__*/React.createElement(Image, {
    src: "/logos/belong_logo_symbol.svg",
    alt: ""
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, null, "Welcome."), /*#__PURE__*/React.createElement(Text, null, "You Belong Here."))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(LinkBase, {
    href: "https://www.facebook.com/belonghome/",
    target: "_blank",
    "aria-label": "Link To Belong Facebook"
  }, /*#__PURE__*/React.createElement(IconFb, {
    height: 24,
    className: "hover:text-dark-navy mr-xl md:mr-sm",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(LinkBase, {
    href: "https://twitter.com/joinbelong",
    target: "_blank",
    "aria-label": "Link To Belong Twitter"
  }, /*#__PURE__*/React.createElement(IconTwitter, {
    height: 24,
    className: "hover:text-dark-navy mr-xl md:mr-sm",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(LinkBase, {
    href: "https://www.linkedin.com/company/belonghq/mycompany/",
    target: "_blank",
    "aria-label": "Link To Belong Linkedin"
  }, /*#__PURE__*/React.createElement(IconLinkedin, {
    height: 24,
    className: "hover:text-dark-navy mr-xl md:mr-sm",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(LinkBase, {
    href: "https://www.instagram.com/belonghm",
    target: "_blank",
    "aria-label": "Link To Belong Instagram"
  }, /*#__PURE__*/React.createElement(IconInstagram, {
    height: 24,
    className: "hover:text-dark-navy",
    "aria-hidden": "true"
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "grid auto-rows-auto\tgap-sm lg:gap-2xs mb-2xs"
  }, BELONG_PRO_LINKS.map(link => {
    if (link.label === 'REFER FOR') {
      const {
        to
      } = link;
      const pathname = routerPathname;
      const href = to || {
        pathname
      };
      return /*#__PURE__*/React.createElement(Link, {
        key: link.label,
        href: href
      }, /*#__PURE__*/React.createElement(Text, {
        variant: "body",
        fontWeight: "semibold",
        className: "lg:p1"
      }, link.label, " ", /*#__PURE__*/React.createElement("span", {
        className: "text-green"
      }, "$1,000")));
    }
    return /*#__PURE__*/React.createElement(FooterLink, {
      key: link.label,
      pathname: routerPathname,
      ...link
    });
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "grid auto-rows-auto\tgap-sm lg:gap-2xs mb-2xs"
  }, WHO_WE_ARE_COLUMN_LINKS.map(link => {
    return /*#__PURE__*/React.createElement(FooterLink, {
      key: link.label,
      pathname: routerPathname,
      ...link
    });
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "grid auto-rows-auto\tgap-sm lg:gap-2xs mb-2xs"
  }, SUPPORT_COLUMN_LINKS.map(link => {
    const linkProps = {
      ...link
    };
    return /*#__PURE__*/React.createElement(FooterLink, {
      key: link.label,
      pathname: routerPathname,
      ...linkProps
    });
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row md:justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-xl md:mb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-lg"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "p1"
  }, "Belong holds real estate, insurance, and financing", ' ', /*#__PURE__*/React.createElement(Link, {
    className: "lowercase",
    variant: "text",
    href: "/licenses"
  }, "licenses"), ", in various states."))), /*#__PURE__*/React.createElement(Text, {
    variant: "p1",
    as: "small"
  }, "Copyright \u00A9 ", new Date().getFullYear(), " Belong, Inc.")));
}

export { Footer };
